////    CORE    ////
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { AppRoutingModule } from 'src/app/app-routing.module'

////    MODULES    ////
import { IconModule } from '@helvetia/components'

////    COMPONENTS    ////
import { HeaderComponent } from './header.component'

@NgModule({
  declarations: [HeaderComponent],
  imports: [CommonModule, AppRoutingModule, IconModule],
  exports: [HeaderComponent],
})
export class HeaderModule {}
